<template>
    <el-container class="openClfxxByERM">
        <el-header>经纪人信息</el-header>
        <el-main >
            <div class="JJrMianBody">
                <el-row>
                    <div slot="header" class="clearfix">
                        <div class="headOne">{{JjjgxxList.JGMC}}</div>
                        <div class="headSecond">{{JjjgxxList.GSDZ}}</div>
                    </div>
                    <el-row>
                        <el-row class="cyryDiv">
                            <el-image class="imgCyrytp"
                                      :src="imgUrl"
                            ></el-image>
                        </el-row>
                    </el-row>
                </el-row>
                <el-row class="SpanRow">
                        <span class="xxContent1">
                        姓名：
                    </span>
                    <span class="xxContent2">
                        {{JjjgxxList.XM}}
                    </span>
                </el-row>
                <el-row class="SpanRow">
                    <span class="xxContent1">
                        从业编号：
                    </span>
                    <span class="xxContent2">
                        {{JjjgxxList.CYBH}}
                    </span>
                </el-row>
                <el-row class="SpanRow">
                    <span class="xxContent1">
                        资格证编号：
                    </span>
                    <span class="xxContent2">
                        {{JjjgxxList.ZGZBH}}
                    </span>
                </el-row>
                <el-row class="SpanRow">
                    <span class="xxContent1">
                        联系方式：
                    </span>
                    <span class="xxContent2">
                        {{JjjgxxList.LXFS}}
                    </span>
                </el-row>
                <el-row class="SpanRow">
                    <span class="xxContent1">
                        所属公司：
                    </span>
                    <span class="xxContent2">
                        {{JjjgxxList.SSGS}}
                    </span>
                </el-row>
                <el-row class="SpanRow">
                    <span class="xxContent1">
                        公司备案号：
                    </span>
                    <span class="xxContent2">
                        {{JjjgxxList.GSBAH}}
                    </span>
                </el-row>
            </div>
        </el-main>
    </el-container>
</template>

<script>
	import axios from 'axios';
	import config from "@/config";
	const base_url = config.baseUrl + 'clf/';
    export default {
        name: "ClfopenJjrxx",
        data() {
            return {
				grxh: 0,
                JjjgxxList:{
                    JGMC:'汉中鸿润置业有限公司',
                    GSDZ:'汉中市汉台区汉中颐高互联网双创园',
                    BAZH:'某某',
                },
                imgUrl: require("../../img2/clf/man.png"),
            }
        },
        created() {
			this.grxh = this.$route.query.grxh;
			axios.get(base_url + "clfxx_jjrxx" + "?grxh=" + this.grxh).then(response => {
				if (!response.data.imgUrl) return;
				this.imgUrl = require("/src/" + response.data.imgUrl);
				this.JjjgxxList = response.data;
			}).catch(error => console.log(error, "error"));
        },
    }
</script>

<style scoped>
    @import "../../assets/css/clf/openClfJjrxx.css";
</style>